import { KeyPressListener } from "./KeyPressListener";
import {
  DIRECTION_DOWN,
  DIRECTION_LEFT,
  DIRECTION_RIGHT,
  DIRECTION_UP,
} from "../helpers/consts";

export class DirectionControls {
  constructor({ editKey, playKey, restartKey }) {
    this.directionKeys = {
      ArrowDown: DIRECTION_DOWN,
      ArrowUp: DIRECTION_UP,
      ArrowLeft: DIRECTION_LEFT,
      ArrowRight: DIRECTION_RIGHT,

      s: DIRECTION_DOWN,
      w: DIRECTION_UP,
      a: DIRECTION_LEFT,
      d: DIRECTION_RIGHT,
    };
    this.heldDirections = [];
    this.mobileDirection = null;

    //Bind single press commands
    this.editModeKeyCommand = new KeyPressListener("KeyE", () => {
      editKey();
    });
    this.playModeKeyCommand = new KeyPressListener("KeyQ", () => {
      playKey();
    });
    this.restartLevelKeyCommand = new KeyPressListener("KeyR", () => {
      restartKey();
    });

    this.directionKeyDownHandler = (e) => {
      const dir = this.directionKeys[e.key];
      if (dir && this.heldDirections.indexOf(dir) === -1) {
        this.heldDirections.unshift(dir);
      }
    };

    this.directionKeyUpHandler = (e) => {
      const dir = this.directionKeys[e.key];
      const index = this.heldDirections.indexOf(dir);
      if (index > -1) {
        this.heldDirections.splice(index, 1);
      }
    };

    document.addEventListener("keydown", this.directionKeyDownHandler);
    document.addEventListener("keyup", this.directionKeyUpHandler);
  }

  get direction() {
    return this.heldDirections[0] ?? this.mobileDirection;
  }

  mobileDpadPress(direction) {
    this.mobileDirection = direction;
  }

  mobileDpadRelease() {
    this.mobileDirection = null;
  }

  unbind() {
    this.editModeKeyCommand.unbind();
    this.playModeKeyCommand.unbind();
    this.restartLevelKeyCommand.unbind();
    document.removeEventListener("keydown", this.directionKeyDownHandler);
    document.removeEventListener("keyup", this.directionKeyUpHandler);
  }
}
